/*===========================================================
addcart.js
一覧からカートへ登録
===========================================================*/
var send_url = "?mode=cart-only";
var CART_BTN = ".detail-add-cart";
var cart_container = $("#list-cart-container");
var SUBMIT_BTN = "input.detail-cart-submit-btn";

var flag = false;

$(function(){
   
   /*----------------------------------------
   addCart
   -----------------------------------------*/
   var current_item_id = null;
   
   var flag = false;
   var target_id = "";
   var item_id = "";
   var header_cart_id = "";
   var item_name = "#item-name-"
   var item_price = "#item-price-";
   var item_image = "#item-thumb-";
   var item_color = "#item-color-";
   var item_size = "#item-size-";
   var name = "";
   var price = "";
   var image = "";
   var color = "";
   var size = "";
   var targetForm = "";
   var position_mode = false;
   var height = 0;
   var display = "";
   
   var submit_options = {
      //type : 'POST',
      url : "/cart/?act=list-item",
      dataType : 'json',
      success : addCartComplete,
      error : function(XMLHttpRequest, textStatus, errorThrown){alert(errorThrown);}
   }
      
   $(SUBMIT_BTN).click(function(e){
      header_cart_id = "header-cart-list-";
      
      var submit_id = "form#"+$(this).parent().attr("id");
      
      item_id = $(this).parent().attr("id").split("-")[3];
      name  = $(item_name+item_id).text();
      price = $(item_price+item_id).text();
      
      if ( $(this).parent().attr("data-thumb-url") != "" ) {
         image = $(this).parent().attr("data-thumb-url");
      } else {
         image = $(item_image+item_id).attr("src");
      }
      
      if($(this).parent().attr("id").split("-")[4] != ""){
         item_id += "-" + $(this).parent().attr("id").split("-")[4];
      }
      
      color = $('.item-info-color', submit_id).text();
      size  = $('.item-info-size', submit_id).text();
      
      header_cart_id += item_id;
      
      //alert(header_cart_id);
      
      $(submit_id).ajaxForm(submit_options);
      $(submit_id).submit(function(){
         $(this).ajaxSubmit();
         return false;
      });
      //return false;
   });
   
   function addCartComplete(responseText){
      if(responseText.result == "false"){
         if ( responseText.message ) {
            alert(responseText.message);
         } else {
            alert('カートに追加できませんでした')
         }
      } else {
         //alert(header_cart_id);
         if(idCheck(header_cart_id)){
            
            $('tr#no-item','.tbl-headcart').remove();
            
            //ヘッダに要素追加
            var add_html = '<tr id="' + header_cart_id + '">'+
                              '<td class="cart-img">'+
                                 '<a href="' + location.hostname + "/item/" + item_id + '">'+
                                    '<img src="' + image + '" alt="' + name + '" width="54" height="66" />'+
                                 '</a>'+
                              '</td>'+
                              '<td>'+
                                 '<a href="' + location.hostname + "/item/" + item_id + '">'+
                                    name + " " + color + " " + 
                                 '</a><br />'+ 
                                 '<span>カラー : ' + color + '</span><br />' +
                                 '<span>サイズ : ' + size + '</span>' +
                                 '<p>'+ price +'円</p>'+
                              '</td>'+
                           '</tr>';
            $("#header-cart-box-view div table.tbl-headcart").append(add_html);
            
            var new_price = eval($("#header-cart-price span.total_price").text().replace(/,/, "")) + eval(price.replace(/,/, ""));
            $(".header-cart-price span.total_price").text(addFigure(new_price));
            
            var total = eval($("#header-cart-price span.total").text()) + 1;
            $(".header-cart-price span.total").text(total);
            
            /*if($('tr','.tbl-headcart').size() < 5){
               $('#header-cart-box-contents div').css('height', 'auto');
            }else{
               $('#header-cart-box-contents div').css('height', '345px');
            }*/
            
            //alert($("#header-cart-box-contents div table").height());
            
            if($('#header-cart-box-view').filter(':not(:hidden)').length == 0){
               $('#header-cart-box-view').show();
            }
            
            var target =$("#header-cart-box-contents div");
            target.animate({ scrollTop: "10000"}, 'slow');
            showMessage("カートに追加しました");
            
            //GA分析用リクエスト
            dataLayer.push({
               'event': 'addToCart',
               'ecommerce': {
                  'add': {
                     'products': [{
                        'name'      : $('.name', '.item-info').text(),
                        'id'        : $('.id', '.item-info').text(),
                        'price'     : $('.price', '.item-info').text(),
                        'brand'     : $('.brand', '.item-info').text(),
                        'category'  : $('.category', '.item-info').text(),
                        'quantity'  : 1,
                        'dimension2': $('.id', '.item-info').text()
                     }]
                  }
               }
            });
            
            /*
            ga('ec:addProduct', {
               id: item_id.split('-').pop(),
               name: name,
               brand: $('div.here li:first').text().trim(),
               category: function(){var a=new Array(); $('div.here li:not(:first,:last)').each(function(){a.push($(this).text().trim())}); return a.join('/');}(),
               price: price.replace(',', ''),
               quantity: 1,
               dimension2: item_id.split('-').shift(),
               dimension3: color,
               dimension4: size
            });
            ga('ec:setAction', 'add');
            ga('send', 'event', 'UX', 'click', 'add to cart');
            */
            
            /* XrossData 2016.07.19追加 */
            if( typeof(__custom_param) === "object" && typeof(__push_beacon) === "function" ) {
                var oa = __action;
                __action = "cartin";
                if( window.location.href.match(/:\/\/[^\/]+\/arrive/) ) {
                    var dd = jQuery("#list-cart-form-"+item_id).closest("dd");
                    var vu = dd.find("div.info h3 a").attr("href");
                    __custom_param = {
                        "pid"       : item_id.split('-').shift(),
                        "p_name"    : name,
                        "p_price"   : price.replace(/[^0-9]/g,''),
                        "p_num"     : 1,
                        "p_img_url" : image,
                        "view_url"  : jQuery('<a>').attr('href',vu).get(0).href
                    };
                    var dp = dd.find("div.info p.price span.sale_price").text().replace(/[^0-9,]/g,'');
                    var lp = dd.find("div.info p.price span.default_price").text().replace(/[^0-9,]/g,'');
                    __custom_param.disp_list_price = lp;
                    if( dp ) {
                        __custom_param.disp_price = dp;
                        __custom_param.price_flg = 2;
                    } else {
                        __custom_param.disp_price = lp;
                        __custom_param.price_flg = 1;
                    }
                }
                __custom_param.sku = item_id.split("-").pop();
                __custom_param.p_num = 1;
                __custom_param.price = __custom_param.p_price;
                __push_beacon(__getURL(), function(){__action=oa;});
            }
            /* XrossDataここまで */
            
         }else{
            showMessage("この商品はカートに入っています");
            /*alert("スルー");*/
         }
         
         flag = false;
      }
   }
   
   function idCheck(_id){
      var text = "";
      var return_value = true;
      
      $("tr",".tbl-headcart").each(function(){
         if($(this).attr("id") == _id){
            return_value = false;
            return false;
         }
         text += $(this).attr("id") + ", ";
      });
      //alert(text+",  "+_id);
      return return_value;
   }
   
   function addFigure(str) {
      var num = new String(str).replace(/,/g, "");
      while(num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      return num;
   }
   
   function showMessage(text){
      $('#container').append('<div class="alert-message"><div class="alert-message-text">'+text+'</div></div>');
      var thisHeight = $(".alert-message").height()/2;
      var thisWidth = $(".alert-message").width()/2;
      //alert(-thisHeight);
      $(".alert-message").css("margin-top",-thisHeight);
      $(".alert-message").css("margin-left",-thisWidth);
      $(".alert-message").animate({opacity:1},500,function(){
         var timer = setInterval(function(){
            clearInterval(timer);
            $(".alert-message").animate({opacity:0},500,function(){
               $(".alert-message").remove();
            });
         },1000);
      });
   }

});



